import { FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'
import { useTheme } from '@mui/system'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import React, { useState } from 'react'
import CustomTextField from '../../components/common/CustomTextField'
import { ProductType, ProductWithStatisticsDto } from '../../services/api/sharedTypes/Product'
import { convertStringToProductType } from '../../utils/product-utils'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import CustomContainer from '../../components/common/CustomContainer'
import CheckBoxContainer from '../../components/common/CheckBoxContainer'

interface ProductBasicInformationProps {
    product: ProductWithStatisticsDto
    setProduct: (product: ProductWithStatisticsDto) => void
}
const ProductBasicInformation: React.FC<ProductBasicInformationProps> = ({
    product,
    setProduct,
}: ProductBasicInformationProps) => {
    const theme = useTheme()

    const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false)

    return (
        <CustomContainer bgColor={theme.palette.background.default} disableMarginTop>

            <Grid container rowSpacing={3} columnSpacing={4}>
                <Grid item md={6} xs={12}>
                    <Grid container rowSpacing={3} columnSpacing={3}>
                        <Grid item xs={12}>
                            <Typography variant='h6' color='primary'>
                                Základní údaje
                            </Typography>
                        </Grid>
                        <Grid item xs={7}>
                            <RadioGroup
                                row
                                value={product.productType}
                                onChange={(e) =>
                                    setProduct({ ...product, productType: convertStringToProductType(Number(e.target.value)) })
                                }
                            >
                                <FormControlLabel value={ProductType.Internal} control={<Radio />} label='Vlastní' />
                                <FormControlLabel value={ProductType.External} control={<Radio />} label='Externí' />
                            </RadioGroup>
                        </Grid>
                        <Grid item xs={5}>
                            <CheckBoxContainer checked={product.canBeAssigned} label='Nabízet k přidávání události' onClick={() => setProduct({ ...product, canBeAssigned: !product.canBeAssigned })} />
                        </Grid>
                        <Grid item xs={6}>
                            <CustomTextField
                                fullWidth
                                size='small'
                                label='Název služby'
                                value={product.name}
                                onChange={(e) => setProduct({ ...product, name: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={['year']}
                                    label='Rok pořízení'
                                    onOpen={() => setIsDatePickerOpen(true)}
                                    onClose={() => setIsDatePickerOpen(false)}
                                    open={isDatePickerOpen}
                                    value={
                                        product.yearOfPurchased === 0 ? null : new Date(product.yearOfPurchased + 1, 0, 0, 0, 0, 0, 0)
                                    }
                                    onChange={(e) => setProduct({ ...product, yearOfPurchased: e?.getFullYear() ?? 0 })}
                                    renderInput={(params) => (
                                        <CustomTextField
                                            fullWidth
                                            size='small'
                                            onClick={() => setIsDatePickerOpen(true)}
                                            {...params}
                                        />
                                    )}
                                    components={{
                                        OpenPickerIcon: () => (
                                            <div
                                                onClick={() => setProduct({ ...product, yearOfPurchased: 0 })}
                                                style={{
                                                    display: product.yearOfPurchased ? '' : 'none',
                                                    marginTop: theme.spacing(1),
                                                }}
                                            >
                                                <CloseOutlinedIcon />
                                            </div>
                                        ),
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={3}>
                            <CustomTextField
                                fullWidth
                                size='small'
                                placeholder='Počet ks'
                                label='Počet ks'
                                value={product.totalQuantity === 0 ? '' : product.totalQuantity}
                                onChange={(e) => {
                                    if (isNaN(Number(e.target.value))) return
                                    setProduct({ ...product, totalQuantity: Number(e.target.value) })
                                }}
                            />
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item md={6} xs={12}>
                    <CustomTextField
                        fullWidth
                        size='small'
                        multiline
                        rows={5}
                        placeholder='Poznámka'
                        label='Poznámka'
                        value={product.note}
                        onChange={(e) => setProduct({ ...product, note: e.target.value })}
                    />
                </Grid>
            </Grid>
        </CustomContainer>

    )
}

export default ProductBasicInformation
